import React from 'react';
import { useDispatch } from 'react-redux';
import { logOut } from '../../redux/auth/authSlice';
import { Navigate } from 'react-router-dom';
import { HOME } from '../../constants/routes';

const LogoutScreen = () => {
    const dispatch = useDispatch();

    dispatch(logOut());

    return <Navigate to={HOME} replace={true} />
};

export default LogoutScreen;